module.exports = __webpack_public_path__ + "img/covid.89d7d155.svg";